<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> {{ pageName }}
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse1" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="4">
                      <TextBox v-model="item.name" placeholder="Name"
                               :addClass="{'is-invalid': $v.item.name.$error}">Name</TextBox>
                    </b-col>
                    <b-col sm="4">
                      <TextBox v-model="item.coin" placeholder="0" type="number"
                               :addClass="{'is-invalid': $v.item.coin.$error}">Min. Coins</TextBox>
                    </b-col>
                    <b-col sm="4">
                      <SelectBox :items="statuses" v-model="item.status">Status</SelectBox>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-end">
                    <div class="form-actions">
                      <b-button right type="submit" variant="primary" @click="onSubmit">Save</b-button>
                      <router-link type="cancel" class="btn btn-secondary" variant="secondary" :to="'/degree'">Cancel</router-link>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {integer, required} from 'vuelidate/lib/validators'

export default {
  name: 'QuestionAddEditPage',
  data () {
    return {
      item: {},
      statuses: [
        {text: 'Active', value: 'ACTIVE'},
        {text: 'Inactive', value: 'INACTIVE'}
      ]
    }
  },
  created () {
    if (!this.$route.params.id || this.$route.params.id <= 0) {
      this.item.status = 'ACTIVE'
      return
    }
    this.$loading.show()
    this.axios.get('telegram-member-degree/item', {params: {id: this.$route.params.id}})
      .then(response => {
        this.item = response.data.data
        if (this.item.active) {
          this.item.status = 'ACTIVE'
        } else {
          this.item.status = 'INACTIVE'
        }
        this.$loading.hide()
      })
      .catch(error => {
        this.$loading.hide()
        if (error.response && error.response.data.status === 400) {
          this.$toastr.error(error.response.data.message)
        }
      })
  },
  computed: {
    pageName () {
      return this.$route.params.id ? 'Edit Degree' : 'Add Degree'
    }
  },
  methods: {
    onSubmit () {
      if (this.$v.item.$invalid) {
        this.$v.$touch()
        return
      }
      if (this.item.status === 'ACTIVE') {
        this.item.active = true
      } else {
        this.item.active = false
      }
      this.$loading.show()
      let axios
      if (this.item.id) {
        axios = this.axios.put('telegram-member-degree/item', this.item)
      } else {
        axios = this.axios.post('telegram-member-degree/item', this.item)
      }
      axios.then((res) => {
        this.$loading.hide()
        if (res.data && res.data.status === 200) {
          this.$toastr.success(res.data.message)
          this.$router.push('/degree')
        } else {
          this.$toastr.error(res.data.message)
        }
      })
    }
  },
  validations: {
    item: {
      name: {
        required
      },
      coin: {
        integer,
        required
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/degree/DegreeAddEditPage.vue